import { create } from "zustand";

export const usePortal = create((set) => ({
  open: false,
  rootElement: null,
  setPortal: (element) => {
    set({ open: true, rootElement: element });
  },
  closePortal: () => {
    set({ open: false });
  },
}));
